<template>
  <div>
    <canvas style="border:1px solid grey;" width="500" height="500" id="canvas" ref="canvas"/>
    <div v-if="currentX" id="test2">
      <p>Position Data</p>

      <p>X: {{currentX}}</p>
      <p>Page Y: {{currentY}}</p>
      {{rect}}




    </div>
    <div id="test3">

    </div>


    <div id="question">
      <img src="img/img1.png" />
    </div>

  </div>



</template>

<script>







function draw() {
  ctx.fillRect(rect.startX, rect.startY, rect.w, rect.h);
}




export default {
  name: 'squareExp',
  data() {
    return {
      canvas: null,
      ctx: null,
      rect: {},
      drag: false,
      currentX: null,
      currentY: null,
      boxes: [],
      saved: [{"left":25,"top":27,"width":89,"height":69},{"left":136,"top":27,"width":64,"height":40},{"left":211,"top":10,"width":56,"height":40}],
      question: null,

    }
  },
  mounted() {
    this.canvas = document.getElementById('canvas')
    this.ctx = canvas.getContext('2d')
    this.canvas.addEventListener('mousemove', this.mouseMove, false);
    canvas.addEventListener('mouseup', this.mouseUp, false);
    canvas.addEventListener('mousedown', this.mouseDown, false);

    let img = new Image()
    img.src = 'neuro/Slide7.png'
    let test = document.getElementById('canvas')
    test.height = img.height
    test.width = img.width
    this.ctx.drawImage(img, 5, 5);

    this.question = document.getElementById('question')
    this.saved.forEach(item => {
      this.drawBoxQuestion(this.question.offsetLeft + item.left,this.question.offsetTop + item.top,item.width,item.height)
    })



    //this.drawBox(1000)
    //https://atomicrobotdesign.com/blog/javascript/draw-a-rectangle-using-the-mouse-on-the-canvas-in-less-than-40-lines-of-javascript/
  },
  methods: {
    drawBox(x, y, width, height) {
      var parent = document.getElementById('test2')
      var g = document.createElement('div');
      g.style.height = height + "px";
      g.style.width =  width + "px";
      g.style.left = x + 'px';
      g.style.top = y + 'px';
      g.style.position = 'absolute'
      g.style.background = 'orange'
      g.addEventListener('click', function() {
        this.parentElement.removeChild(this)
      })
      parent.appendChild(g)

    },

    drawBoxQuestion(x, y, width, height) {
      var parent = document.getElementById('question')
      var g = document.createElement('div');
      g.style.height = height + "px";
      g.style.width =  width + "px";
      g.style.left = x + 'px';
      g.style.top = y + 'px';
      g.style.position = 'absolute'
      g.style.background = 'orange'
      g.addEventListener('click', function() {
        this.parentElement.removeChild(this)
      })
      parent.appendChild(g)

    },

    mouseMove(e) {
      this.currentX = e.pageX - this.canvas.offsetLeft
      this.currentY = e.pageY - canvas.offsetTop

      if (this.drag) {
        this.rect.w = this.currentX - this.rect.startX
        this.rect.h = this.currentY - this.rect.startY
        //this.draw();
      }

    },
    mouseDown(e) {
      this.rect.startX = this.currentX
      this.rect.startY = this.currentY
      this.drag = true
      //console.log('Click')
    },
    mouseUp() {
      this.drag = false
      //console.log('Unclick')
      this.drawBox(this.canvas.offsetLeft + this.rect.startX, this.canvas.offsetTop + this.rect.startY, this.rect.w, this.rect.h)
      this.boxes.push({
        left: this.rect.startX / this.canvas.width,
        top: this.rect.startY / this.canvas.height,
        width: this.rect.w / this.canvas.width,
        height: this.rect.h / this.canvas.height
      })
      console.log(JSON.stringify(this.boxes))
      console.log('mark222')
    },
    draw() {
      this.ctx.fillRect(this.rect.startX, this.rect.startY, this.rect.w, this.rect.h);

    }

  }

}
</script>

<style>
.resizable {
  background: blue;
  width: 100px;
  height: 100px;
  position: absolute;
  top: 100px;
  left: 100px;
}
#test2 {
  border: 1px solid black;
  height: 500px;
  width: 1000px;
}
</style>
